var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalFillIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C15.7279 15 18.75 12.0899 18.75 8.5C18.75 4.91015 15.7279 2 12 2C8.27208 2 5.25 4.91015 5.25 8.5C5.25 12.0899 8.27208 15 12 15Z",
    fill: "#F56116"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.79 15.6101C16.12 15.4401 16.5 15.6901 16.5 16.0601V20.9101C16.5 21.8101 15.87 22.2501 15.09 21.8801L12.41 20.6101C12.18 20.5101 11.82 20.5101 11.59 20.6101L8.91 21.8801C8.13 22.2401 7.5 21.8001 7.5 20.9001L7.52 16.0601C7.52 15.6901 7.91 15.4501 8.23 15.6101C9.36 16.1801 10.64 16.5001 12 16.5001C13.36 16.5001 14.65 16.1801 15.79 15.6101Z",
    fill: "#F56116"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalFillIcon);
export default __webpack_public_path__ + "static/media/medal-fill-icon.6a7148f802d7deeb6788aa99b7b174f1.svg";
export { ForwardRef as ReactComponent };